module.exports = __webpack_public_path__ + "img/rz-circle.7eb38dc6.svg";